import React, { useLayoutEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
// Importing geodata (map data)
import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import "./assets/css/map.css";
import Formatter from "../../../../services/utils/Formatter";

am4core.useTheme(am4themes_animated);

interface MapaProps {
  id: string;
  data: object[];
}

const Mapa: React.FC<MapaProps> = ({ data }) => {
  useLayoutEffect(() => {
    let x = am4core.create("map", am4maps.MapChart);

    x.hiddenState.properties.opacity = 0;
      x.background.visible = false;
      x.language.locale["_decimalSeparator"] = ",";
		x.language.locale["_thousandSeparator"] = "."; 

    // Set map definition
    x.geodata = am4geodata_worldLow;

    // Set projection
    x.projection = new am4maps.projections.Miller();

    // Create map polygon series
    var polygonSeries = x.series.push(new am4maps.MapPolygonSeries());

    // Exclude Antartica
    //polygonSeries.exclude = ["AQ"];

    // Make map load polygon (like country names) data from GeoJSON
    polygonSeries.useGeodata = true;

    // Configure series
    var polygonTemplate = polygonSeries.mapPolygons.template;
    polygonTemplate.tooltipText = "{name}";
    polygonTemplate.fill = am4core.color("#f6f8fc");
    polygonTemplate.stroke = am4core.color("#a7b9db");

    // Create hover state and set alternative fill color
    var hs = polygonTemplate.states.create("hover");
    hs.properties.fill = am4core.color("#a7b9db");
    //hs.properties.fill = chart.colors.getIndex(0);

    //Add only these countries
    polygonSeries.include = [
      "BR",
      "PY",
      "UY",
      "AR",
      "CL",
      "BO",
      "PE",
      "EC",
      "CO",
      "VE",
      "GY",
      "SR",
      "GF",
      "PA",
      "CR",
      "NI",
      "HN",
      "SV",
      "GT",
      "BZ",
      "MX",
      "PR",
      "DO",
      "HT",
      "JM",
      "CU"
    ];

    // Zoom control
    x.zoomControl = new am4maps.ZoomControl();
    x.chartContainer.wheelable = false;

    var homeButton = new am4core.Button();
    homeButton.events.on("hit", function () {
      x.goHome();
    });

    homeButton.icon = new am4core.Sprite();
    homeButton.padding(7, 5, 7, 5);
    homeButton.width = 32;
    homeButton.icon.path =
      "M16,8 L14,8 L14,16 L10,16 L10,10 L6,10 L6,16 L2,16 L2,8 L0,8 L8,0 L16,8 Z M16,8";
    homeButton.marginBottom = 10;
    homeButton.parent = x.zoomControl;
    homeButton.insertBefore(x.zoomControl.plusButton);
    //homeButton.fill = am4core.color("#00162b");

    // Add image series
    var imageSeries = x.series.push(new am4maps.MapImageSeries());
    imageSeries.mapImages.template.propertyFields.longitude = "longitude";
    imageSeries.mapImages.template.propertyFields.latitude = "latitude";
    imageSeries.data = data;

    // add events to recalculate map position when the map is moved or zoomed
    x.events.on("ready", updateCustomMarkers);
    x.events.on("mappositionchanged", updateCustomMarkers);

    // this function will take current images on the map and create HTML elements for them
    function updateCustomMarkers(event: any) {
      // go through all of the images
      imageSeries.mapImages.each(function (image) {
        // check if it has corresponding HTML element
        if (!image.dummyData || !image.dummyData.externalElement) {
          // create onex
          image.dummyData = {
            externalElement: createCustomMarker(image)
          };
        }

        // reposition the element accoridng to coordinates
        var xy = x.geoPointToSVG({
          longitude: image.longitude,
          latitude: image.latitude
        });
        image.dummyData.externalElement.style.top = xy.y + "px";
        image.dummyData.externalElement.style.left = xy.x + "px";
      });
    }

    // this function creates and returns a new marker element
    function createCustomMarker(image: any) {
      var chart = image.dataItem.component.chart;
      let context: any = image.dataItem.dataContext;
      let size: number = context.size;
      let color: string = context.value > 0 ? "blue" : "red";

      // create holder
      var holder = document.createElement("div");
      holder.className = "map-marker";
      holder.title = image.dataItem.dataContext.title;
      holder.style.position = "absolute";

      // maybe add a link to it?
      if (undefined !== image.url) {
        holder.onclick = function () {
          window.location.href = image.url;
        };
        holder.className += " map-clickable";
      }

      // create dot
      var dot = document.createElement("div");
      var dot2 = document.createElement("div");
      dot.className = "map__dot map__dot--" + color;
      dot2.className = "map__dot__container";
      dot2.style.transform = `scale(${ .2 + (size < 100 ? size / 100 : 1) * 1.2 })`;
      dot2.appendChild(dot);
      holder.appendChild(dot2);

      // create pulse
      var pulse = document.createElement("div");
      pulse.className = "pulse map__pulse--" + color;
      pulse.style.transform = `scale(${size < 100 ? size / 100 : 1})`;
      holder.appendChild(pulse);

      // create value label
      var value = document.createElement("span");
      value.className = "label";
      value.innerHTML = Formatter.FormatNumber(image.dataItem.dataContext.value)[0];
      value.style.top = `${50 + 50 * (size < 100 ? size / 100 : 1)}%`;
      holder.appendChild(value);

      // append the marker to the map container
      chart.svgContainer.htmlElement.appendChild(holder);

      return holder;
    }

    /*--------------------------------------------------------------------------------------*/
    //chart.current = x;

    return () => {
      x.dispose();
    };
  }, [data]);

  return <div className="chart" id="map"></div>;
};

export default Mapa;
